var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery31"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery30"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery29"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery28"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery27"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery26"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery25"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery24"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery23"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery22"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery21"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery20"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery19"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery18"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery17"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery16"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery14"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery13"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery12"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,14.75c-0.0967,0-0.1938-0.0142-0.2871-0.042l-10-3c-0.5293-0.1587-0.8296-0.7163-0.6709-1.2451    C5.2012,9.9331,5.7588,9.6343,6.2871,9.792L16,12.7061l9.7129-2.9141c0.5288-0.1543,1.0859,0.1416,1.2451,0.6709    c0.1587,0.5288-0.1416,1.0864-0.6709,1.2451l-10,3C16.1938,14.7358,16.0967,14.75,16,14.75z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,11v12.75c0,0.41-0.25,0.78-0.63,0.93l-10,4c-0.12,0.05-0.24,0.07-0.37,0.07s-0.25-0.02-0.37-0.07    l-10-4C5.25,24.53,5,24.16,5,23.75V11c0-0.55,0.45-1,1-1h20C26.55,10,27,10.45,27,11z",
    fill: "#48B1DD"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.99,7.91c-0.06,0.38-0.34,0.69-0.7,0.8l-10,3C6.19,11.74,6.1,11.75,6,11.75    c-0.24,0-0.47-0.09-0.66-0.25l-4-3.5C1.07,7.77,0.95,7.4,1.02,7.05S1.34,6.41,1.68,6.3l9-3c0.3-0.1,0.63-0.05,0.89,0.13l5,3.5    C16.89,7.15,17.05,7.53,16.99,7.91z",
    fill: "#96CEE5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.66,8l-4,3.5c-0.19,0.16-0.42,0.25-0.66,0.25c-0.1,0-0.19-0.01-0.29-0.04l-10-3    c-0.36-0.11-0.64-0.42-0.7-0.8s0.1-0.76,0.42-0.98l5-3.5c0.26-0.18,0.59-0.23,0.89-0.13l9,3c0.34,0.11,0.59,0.4,0.66,0.75    S30.93,7.77,30.66,8z",
    fill: "#96CEE5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,10.75c0,0.44-0.29,0.83-0.71,0.96l-10,3c-0.1,0.03-0.19,0.04-0.29,0.04s-0.19-0.01-0.29-0.04l-10-3    C5.29,11.58,5,11.19,5,10.75s0.29-0.83,0.71-0.96l10-3c0.19-0.05,0.39-0.05,0.58,0l10,3C26.71,9.92,27,10.31,27,10.75z",
    fill: "#4391B2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.83,14.3l-4,6c-0.19,0.29-0.5,0.45-0.83,0.45c-0.12,0-0.25-0.02-0.37-0.07l-10-4    c-0.3-0.12-0.52-0.37-0.6-0.67C0.95,15.7,1.02,15.37,1.22,15.13l4-5c0.25-0.32-0.5162-0.8181-0.1262-0.7081L16.29,12.79    c0.3,0.09,0.54,0.32,0.65,0.62S17.01,14.04,16.83,14.3z",
    fill: "#96CEE5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.97,15.94c-0.08,0.3-0.3,0.56-0.59,0.67l-10,4.07c-0.13,0.05-0.25,0.07-0.38,0.07    c-0.33,0-0.64-0.16-0.83-0.45l-4-6c-0.18-0.26-0.22-0.59-0.11-0.89s0.35-0.53,0.65-0.62l11.0244-3.3056    c0.39-0.12-0.2144,0.3256,0.0457,0.6356l4,4.94C30.98,15.3,31.05,15.63,30.97,15.94z",
    fill: "#96CEE5"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery10"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery09"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery08"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery07"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery06"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery05"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery04"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery03"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery02"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.a6a6eea910d3bd9a3444617608fbbfa3.svg";
export { ForwardRef as ReactComponent };